module.exports = __webpack_public_path__ + "img/logement-espace-exterieur-sans.6a4bb254.png";